import { render, staticRenderFns } from "./DigitalHumanKnowledgeBase.vue?vue&type=template&id=9d154592&scoped=true"
import script from "./DigitalHumanKnowledgeBase.vue?vue&type=script&lang=ts"
export * from "./DigitalHumanKnowledgeBase.vue?vue&type=script&lang=ts"
import style0 from "./DigitalHumanKnowledgeBase.vue?vue&type=style&index=0&id=9d154592&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d154592",
  null
  
)

export default component.exports